import styled, {keyframes, css} from 'styled-components';
import React, { Component } from 'react';

class Day extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
        <BubbleBox>
            <DayBubble Selected={this.props.Selected} for={this.props.for}>{this.props.children}</DayBubble>
        </BubbleBox>
        );
    }
}

export class BDayDays extends Component {
    constructor(props) {
        super(props);
        this.state = {
            January: 31,
            February: 29,
            March: 31,
            April:30,
            May:31,
            June:30,
            July:31,
            August:31,
            September:30,
            October:31,
            November:30,
            December:31
        }
    }
    handleChange =  e => {
        this.props.updateDay(e.target.value);
    }
    render() {
        var x = [];
        var mo = this.props.Month;
        for(var i = 1; i <= this.state[mo]; i++){
            x.push(i);
        }
        return(
            <DayBox Display={this.props.Display}>
                <div style={{position:'absolute',left:'0', top:'0', padding: '10px'}}>
                    <div onClick={this.props.onClick} name="backBtn" style={{cursor:'pointer'}}>
                    &#171;BACK
                    </div>
                </div>
                <div style={{textAlign:'center', margin:'10px'}}>
                    {this.props.Month}
                </div>
                {x.map(i => {return(
                    <Day for={i} Selected={((i == this.props.Day) ? true : false)}>{i}<Radio onClick={this.props.onClick} name="BDay" id={i} value={i} type="radio" onChange={this.props.onChange} checked={this.props.Day == i}/></Day>
                )})}
            </DayBox>
        );
    }
}

export class BDayMonths extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        var Months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        return(
            <MonthBox Display={this.props.Display}>
                {Months.map(i => {
                    return <MoBubbleBox>
                                <MonthBubble Selected={((i == this.props.Month) ? true : false)}>{i}<Radio onClick={this.props.onClick} name="BMonth" onChange={this.props.onChange} id={i} value={i} type="radio"  checked={this.props.Month == i}/></MonthBubble>
                            </MoBubbleBox>
                })}
            </MonthBox>
        );
    }
}

export function Winter({Month}) {
    if(parseInt(Month) === 12 || parseInt(Month) === 1 || parseInt(Month) === 2) {
        return(<span style={{height: '50px'}}>&#9924;</span>);
    } else {
        return null;
    }
}

export function Summer({Month}) {
    if(parseInt(Month) >= 6 && parseInt(Month) <= 8) {
        return(<span style={{color:'#cca300', width: '50%'}}>&#9728;</span>);
    }else {
        return null;
    }
}   
export function Spring({Month}) {
    if(parseInt(Month) >= 3 && parseInt(Month) <= 5) {
        return(<span style={{width: '50%'}}>&#9748;</span>);
    }else {
        return null;
    }
}
export function Fall({Month}) {
    if(parseInt(Month) >= 9 && parseInt(Month) <= 11) {
        return(<span style={{width: '50%'}}>&#9749;</span>);
    }else {
        return null;
    }
}

export class Birthday extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div>
                <BG name='BG' Display={this.props.Display.BG} onClick={this.props.onClick} />
                <BDayMonths Display={this.props.Display.Month} onClick={this.props.onClick} onChange={this.props.onChange} Month={this.props.Month} />
                <BDayDays Display={this.props.Display.Day} onChange={this.props.onChange} onClick={this.props.onClick} Month={this.props.Month} Day={this.props.Day} />
            </div>
        );
    }
}

export class BDayBtn extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return(
            <BtnDiv>
                <BdayTxt>Tell us your birthday! <br/><AddedTxt>(don't worry, we won't ask for the year &#128521;)</AddedTxt></BdayTxt>
                <Btn name="Btn" onClick={this.props.onClick}>{this.props.children}</Btn>
            </BtnDiv>
        );
    }
}

export const BG = styled.div`
    width: 70vw;
    height: 100vh;
    background-color: rgba(255,255,255,.6);
    position: absolute;
    z-index: 10;
    display: ${props => (props.Display ? 'block' : 'none')};
    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`;

const BtnDiv = styled.div`
    width: 100%;
    height: 120px;
    @media only screen and (max-width: 500px) {
        margin: auto;
    }
    @media only screen and (min-width: 3839px) {
        height: 220px;
    }
`;

const Btn = styled.button`
    margin:auto;
    height: 50px;
    float: left;
    border-radius: 30px; 
    border-style: none;
    background-color: rgba(203,217,211,.4);
    text-transform: uppercase;
    font-family: 'Gotham Book';
    font-size: 15px;
    color: rgb(107,108,109);
    cursor: pointer;
    @media only screen and (max-width: 500px) {
        font-size:1.2em;
        width: 25%;
        margin: 0 10%;
    }
    & > * {
        pointer-events: none;
    }
    @media only screen and (max-width: 320px) {
        width: 60%;
    }
    @media only screen and (min-width: 3839px) {
        height: 100px;
        font-size: 30px;
    }
`;

const AddedTxt = styled.span`
    font-size:12px;
    text-transform:none;
    @media only screen and (min-width: 3839px) {
        font-size:20px;
    }
`;

const BdayTxt = styled.p`
    text-transform:uppercase;
    float: left;
    line-height: .8em;
    width: 100%;
    color: #4E757E;
    margin: 0 0 .8em 0;
    font-family: 'Gotham Book';
    @media only screen and (max-width: 500px){
        width: 80%;
    }
    @media only screen and (max-width: 280px) {
        height: auto;
    }
    @media only screen and (min-width: 3839px) {
        font-size:30px;
    }
`;

const MonthBubble = styled.label`
    width: 120px;
    font-family: 'Gotham Book';
    position: relative;
    height: 48px;
    text-transform: uppercase;
    border-color: #4E757E;
    border-style: solid;
    border-width: 2px;
    margin: 2px;
    border-radius: 30px;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    color: ${props => (props.Selected ? '#4E757E' : 'white')};
    background-color: ${props => (props.Selected ? 'white' : '#4E757E')};
    transition-duration: .5s;
    transform-origin: 50% 50%;
    display:inline-block;
    cursor: pointer;
    :hover {
        width: 124px;
        height: 50px;
        font-size: 18px;
        line-height: 50px;
        margin: 0;
    }
    @media only screen and (max-width: 500px){
        width: 95%;
        height: 14.5%;
    }
    @media only screen and (max-width: 320px) {
        font-size:1.4em;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        width: 94%;
        height: 120px;
        line-height: 120px;
        font-size: 60px;
        :hover {
            width: 94%;
            height: 120px;
            line-height: 120px;
            font-size: 60px;
            margin: 2px;
        }
    }
`;

const BubbleBox = styled.div`
    width: 53px;
    height: 53px;
    margin: 0;
    padding: 0;
    float: left;
    position: relative;
    @media only screen and (max-width: 500px){
        width: 16vw;
        height: 16vw;
    }
    @media only screen and (max-width: 320px) {
        font-size:.8em;
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :)*/
        width: 16%;
        height: auto;
    }
`;

const MoBubbleBox = styled.div`
    width: 128px;
    height: 55px;
    margin: 0;
    padding: 0;
    float: left;
    position: relative;
    @media only screen and (max-width: 500px){
        width: 50%;
        height: 15%
    }
    @media only screen and (min-width: 3839px) { /*4k TVs :) */
        width: 50%;
        height: 25%
    }
`;

const Radio = styled.input`
    display: none;
`;

const DayBubble = styled.label`
    width: 48px;
    font-family: 'Gotham Book';
    position: relative;
    height: 48px;
    border-color: #4E757E;
    border-style: solid;
    border-width: 2px;
    margin: 2px;
    border-radius: 50%;
    font-size: 20px;
    line-height: 48px;
    text-align: center;
    color: ${props => (props.Selected ? '#4E757E' : 'white')};
    background-color: ${props => (props.Selected ? 'white' : '#4E757E')};
    transition-duration: .5s;
    transform-origin: 50% 50%;
    display:inline-block;
    cursor: pointer;
    :hover {
        width: 50px;
        height: 50px;
        font-size: 21px;
        line-height: 50px;
        margin: 0;
    }
    @media only screen and (max-width: 500px){
        width: 13vw;
        height: 13vw;
        line-height: 13vw;
        margin: 1vw;
        border-width: 1vw;
    }
    @media only screen and (min-width: 3839px){
        width: 2em;
            height: 2em;
            font-size: 5rem;
            line-height: 2em;
        :hover {
            width: 2em;
            height: 2em;
            font-size: 5rem;
            line-height: 2em;
            margin: 2px;
        }
    }
`;

const MonthBox = styled.div`
    margin: 45% 10%;
    width: 378px;
    height: auto;
    position: absolute;
    top: 0;
    z-index: 19;
    display: ${props => (props.Display ? 'block' : 'none')};
    text-transform: uppercase;
    border-color: #4E757E;
    color: #4E757E;
    @media only screen and (max-width: 500px){
        margin: 45% 0%;
        width: 100%;
        height: auto;
    }
    @media only screen and (min-width: 3839px){
        margin: 45% 0%;
        width: 50%;
        height: auto;
    }
`;
const DayBox = styled.div`
    margin: 45% 10%;
    width: 378px;
    height: auto;
    font-size: 20px;
    position: absolute;
    top: 0;
    z-index:20;
    display: ${props => (props.Display ? 'block' : 'none')};
    text-transform: uppercase;
    border-color: #4E757E;
    color: #4E757E;
    @media only screen and (max-width: 500px) {
        margin: 45% 0%;
        width: 100%;
        height: auto;
    }
    @media only screen and (min-width: 3839px) {
        width: 50%;
    }
`;